import React from 'react'
import { motion } from "framer-motion";
import { MDBContainer } from 'mdb-react-ui-kit';
import { images } from '../data/gallery';
import { useWebsiteContext } from '../context/website_context';
import NavigationButton from './NavigationButton'

const Gallery = () => {

const { showHideGallery, setCurrentImg } = useWebsiteContext();

  return (
    <section id="galery" className="section-image-bg">
            <div className="row d-none d-md-flex justify-content-between align-items-center">
                <div className="col-sm-12 d-flex justify-content-center align-items-center">
                    <NavigationButton mySelector="#left-image" myIcon="chevron-up" hasMargin={false}/>
                    <NavigationButton mySelector="#perfect-getaway" myIcon="chevron-down" hasMargin={true} />
                </div>
                <MDBContainer className="w-75">
                    <div className="col-sm-12 text-center mt-5">
                      <h2 className="title mb-5 text-left display-5">Gallery</h2>
                    </div>
                    <div className="col-sm-12 p-0 d-flex justify-content-center align-items-center flex-wrap my-3">
                        {
                            images.map((img, imgIndex) => {
                                const {id, imgURL } = img;

                                return (
                                    <motion.div key={id} initial={{ opacity: 0}} whileInView={{ opacity: 1}}  transition={{ delay: 0.1, duration: 2}}>
                                        <div className="rounded-5 gallery-img-mask d-flex align-items-center justify-content-center mx-2 mb-3">
                                            <img className="gallery-image d-flex" loading="lazy" src={imgURL} alt={id} 
                                            onClick={() => {
                                                showHideGallery();
                                                setCurrentImg(imgIndex);
                                            }}/>
                                        </div>
                                    </motion.div>
                                )

                            })
                        }
                    </div>
                </MDBContainer>
                <div className="col-sm-12 d-flex justify-content-center align-items-start">
                    <NavigationButton mySelector="#perfect-getaway" myIcon="chevron-down" hasMargin={true} />
                </div>
                <div className="section-diviser"></div>
            </div>
        </section>
  )
}

export default Gallery